export default "__VITE_ASSET__CWGOkr5$__"